import { useCallback } from 'react';
import { useLanguage } from '../context/LanguageContext';
import enTranslations from '../locales/en.json';
import teTranslations from '../locales/te.json';

const translations = {
  en: enTranslations,
  te: teTranslations,
};

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = useCallback((key, params = {}) => {
    const keys = key.split('.');
    let value = translations[language];

    // Navigate through nested keys
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        value = undefined;
        break;
      }
    }

    // Fallback to English if translation not found
    if (!value || typeof value !== 'string') {
      let fallbackValue = translations.en;
      for (const k of keys) {
        if (fallbackValue && typeof fallbackValue === 'object') {
          fallbackValue = fallbackValue[k];
        } else {
          fallbackValue = undefined;
          break;
        }
      }
      value = (fallbackValue && typeof fallbackValue === 'string') ? fallbackValue : key;
    }

    // Replace parameters if any
    if (typeof value === 'string' && params && Object.keys(params).length > 0) {
      Object.keys(params).forEach((param) => {
        value = value.replace(`{{${param}}}`, params[param]);
      });
    }

    return value;
  }, [language]);

  return { t, language };
};
